document.addEventListener('DOMContentLoaded',function(){

/* 1. Card hearts -> navigate to product page */
function wwpPatchHearts(){
  document.querySelectorAll('[data-wwp-wishlist-handle]').forEach(function(btn){
    if(btn.dataset.wwpPatchBound)return;
    btn.dataset.wwpPatchBound='true';
    if(btn.hasAttribute('data-wwp-pdp-heart'))return;
    btn.addEventListener('click',function(e){
      e.preventDefault();e.stopPropagation();
      window.location.href='/products/'+btn.dataset.wwpWishlistHandle;
    },true);
  });
}
wwpPatchHearts();
new MutationObserver(wwpPatchHearts).observe(document.body,{childList:true,subtree:true});

/* 2. Add to Bag label */
function wwpBagLabel(){
  document.querySelectorAll('[name="add"] span:first-child,.product-form__submit span:first-child').forEach(function(el){
    var t=el.textContent.trim();
    if(t==='Add to cart'||t==='Add to Cart')el.textContent='Add to Bag';
  });
}
wwpBagLabel();
new MutationObserver(wwpBagLabel).observe(document.body,{childList:true,subtree:true});

/* 3. Contact link fallback */
document.querySelectorAll('[data-wwp-contact-open]').forEach(function(el){
  if(el.tagName==='A')el.setAttribute('href','/pages/contact');
});

/* 4. Blog tag filter bar */
(function(){
  var blogGrid=document.querySelector('.blog-articles,.blog,.articles-grid,.blog__posts');
  if(!blogGrid||document.querySelector('.wwp-blog-tag-bar'))return;
  var mainTags=['Buying Guide','Dogs','Cats','Grooming','Health','Travel','Wellbeing','At Home'];
  var bar=document.createElement('div');
  bar.className='wwp-blog-tag-bar';
  bar.style.cssText='display:flex;flex-wrap:wrap;gap:8px;padding:0 0 24px;';
  var path=window.location.pathname;
  var activeTag=path.includes('/tagged/')?decodeURIComponent(path.split('/tagged/').pop()).replace(/\/$/,''):'';
  var allA=document.createElement('a');
  allA.href='/blogs/news';allA.textContent='All Posts';
  var isAll=!activeTag;
  allA.style.cssText='padding:7px 16px;border-radius:20px;font-size:13px;font-weight:600;text-decoration:none;border:1.5px solid '+(isAll?'#E0948F':'#D4C4B4')+';background:'+(isAll?'#E0948F':'transparent')+';color:'+(isAll?'#fff':'#6B6560')+';white-space:nowrap';
  bar.appendChild(allA);
  mainTags.forEach(function(tag){
    var a=document.createElement('a');
    a.href='/blogs/news/tagged/'+encodeURIComponent(tag);
    a.textContent=tag;
    var active=activeTag.toLowerCase()===tag.toLowerCase();
    a.style.cssText='padding:7px 16px;border-radius:20px;font-size:13px;font-weight:600;text-decoration:none;border:1.5px solid '+(active?'#E0948F':'#D4C4B4')+';background:'+(active?'#E0948F':'transparent')+';color:'+(active?'#fff':'#6B6560')+';white-space:nowrap';
    bar.appendChild(a);
  });
  blogGrid.parentNode.insertBefore(bar,blogGrid);
})();

/* 5. Free shipping progress bar in cart drawer */
function wwpShippingBar(){
  document.querySelectorAll('.cart-drawer__footer,.cart__footer').forEach(function(footer){
    if(footer.querySelector('.wwp-fs-bar'))return;
    var wrap=document.createElement('div');
    wrap.className='wwp-fs-bar';
    wrap.style.cssText='padding:12px 0 6px;border-bottom:.5px solid #EDE5DA;margin-bottom:10px';
    footer.prepend(wrap);
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var threshold=4000; /* pence = £40 */
      var total=cart.total_price;
      var remaining=threshold-total;
      var pct=Math.min(100,Math.round((total/threshold)*100));
      if(remaining<=0){
        wrap.innerHTML='<p style="text-align:center;font-size:12.5px;font-weight:600;color:#2d7a2d;padding:2px 0">&#127881; You qualify for free delivery!</p>';
      }else{
        var fmt='\u00a3'+(remaining/100).toFixed(2);
        wrap.innerHTML='<p style="font-size:12px;color:#6B6560;text-align:center;margin-bottom:7px">Add <strong style="color:#2B2926">'+fmt+'</strong> more for free delivery</p><div style="height:5px;background:#EDE5DA;border-radius:3px;overflow:hidden"><div style="height:5px;background:#E0948F;border-radius:3px;width:'+pct+'%;transition:width .4s ease"></div></div>';
      }
    }).catch(function(){wrap.remove();});
  });
}
wwpShippingBar();
new MutationObserver(wwpShippingBar).observe(document.body,{childList:true,subtree:true});

/* 6. Continue Shopping in cart */
function wwpContinueShopping(){
  document.querySelectorAll('.cart-drawer__footer,.cart__footer').forEach(function(footer){
    if(footer.querySelector('.wwp-cs'))return;
    var a=document.createElement('a');
    a.href='/collections/shop-all';a.className='wwp-cs';a.textContent='Continue Shopping';
    a.style.cssText='display:block;text-align:center;padding:10px 0 2px;font-size:13px;font-weight:600;color:#6B6560;text-decoration:none;letter-spacing:.02em;transition:color .15s';
    a.onmouseenter=function(){a.style.color='#E0948F';};
    a.onmouseleave=function(){a.style.color='#6B6560';};
    footer.appendChild(a);
  });
}
wwpContinueShopping();
new MutationObserver(wwpContinueShopping).observe(document.body,{childList:true,subtree:true});

/* 7. Reorder reminder on consumable product pages
   Consumable = products people use up and need to buy again.
   Matched on product handle OR page title (case-insensitive).
   Covers: food, water fountain filters, litter, treats, poop bags,
   supplements, vitamins, flea/worm treatments, dental chews/paste,
   shampoo, conditioner, ear cleaner, eye wipes, training pads,
   deodoriser, odour spray, stain remover.
*/
(function(){
  var isProduct=document.querySelector('.product-form__submit,.product__title');
  if(!isProduct)return;
  var handle=window.location.pathname.split('/products/')[1];
  if(!handle)return;
  var consumables=[
    'food','treat','chew','snack','litter','poop-bag','poo-bag','waste-bag','dog-bag',
    'filter','fountain-filter','refill',
    'supplement','vitamin','probiotic','omega','joint',
    'flea','worm','tick','parasite',
    'dental','toothpaste','mouth-spray',
    'shampoo','conditioner','coat-spray',
    'ear-clean','ear-drop','eye-wipe','paw-balm',
    'training-pad','puppy-pad','potty-pad',
    'deodor','odour','stain','enzyme-spray'
  ];
  var title=document.querySelector('.product__title h1,.product-form__title');
  var titleText=title?title.textContent.toLowerCase():'';
  /* Also check title words for common consumable terms */
  var titleWords=[
    'food','treat','chew','snack','litter','poop bag','poo bag','waste bag',
    'bag refill','fountain filter','filter','refill',
    'supplement','vitamin','probiotic','omega','joint support',
    'flea','wormer','tick','dental','toothpaste',
    'shampoo','conditioner','ear cleaner','eye wipe','paw balm',
    'training pad','puppy pad','potty pad',
    'deodoriser','odour','stain remover','enzyme'
  ];
  var isConsumable=consumables.some(function(k){return handle.includes(k);})||
    titleWords.some(function(k){return titleText.includes(k);});
  if(!isConsumable)return;
  var form=document.querySelector('.product-form');
  if(!form||form.querySelector('.wwp-reorder'))return;
  var div=document.createElement('div');
  div.className='wwp-reorder';
  div.style.cssText='background:#F9F4EE;border-radius:10px;padding:12px 16px;margin:12px 0;display:flex;align-items:flex-start;gap:10px;border:.5px solid #EDE5DA';
  div.innerHTML='<div><p style="font-size:13px;font-weight:600;color:#2B2926;margin-bottom:2px">Need this regularly?</p><p style="font-size:12px;color:#6B6560;line-height:1.5">Create a free account and we\'ll remind you when it\'s time to reorder — no subscription required.</p><a href="/account/register" style="font-size:12px;font-weight:600;color:#E0948F;text-decoration:none;display:inline-block;margin-top:4px">Set up a reorder reminder →</a></div>';
  form.insertAdjacentElement('afterend',div);
})();

/* 8. Product card hover border */
(function(){
  var style=document.createElement('style');
  style.textContent='.card-wrapper:hover .card{border-color:#CA9365!important;transition:border-color .2s ease}';
  document.head.appendChild(style);
})();

/* 9. Low-stock label */
(function(){
  function wwpStampLowStock(){
    document.querySelectorAll('.wwp-low-stock').forEach(function(el){
      var m=el.textContent.match(/(\d+)/);
      if(m)el.setAttribute('data-qty',m[1]);
    });
  }
  wwpStampLowStock();
  new MutationObserver(wwpStampLowStock).observe(document.body,{childList:true,subtree:true});
})();

/* Mobile burger search */
(function(){
  var header=document.querySelector('.wwp-mm-header');
  if(!header)return;
  var h3=header.querySelector('h3');
  if(!h3)return;
  var form=document.createElement('form');
  form.className='wwp-mm-search-form';
  form.method='get';
  form.action='/search';
  form.setAttribute('role','search');
  form.innerHTML='<input type="search" name="q" placeholder="Search for pet products..." aria-label="Search" style="flex:1;min-width:0;border:none;background:transparent;padding:9px 6px 9px 16px;font-size:1.3rem;color:#2B2926;outline:none"><button type="submit" aria-label="Search" style="border:none;background:#E0948F;color:#FFFDFB;padding:0 16px;align-self:stretch;display:flex;align-items:center;cursor:pointer"><svg viewBox="0 0 18 19" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="7" cy="7" r="5"/><line x1="11" y1="11" x2="16" y2="16"/></svg></button>';
  form.style.cssText='flex:1 1 auto;display:flex;align-items:center;border:1px solid #CA9365;border-radius:40px;overflow:hidden;background:#FFFDFB;min-width:0';
  h3.replaceWith(form);
})();

});

/* ---- PATCH v5 ---- */

document.addEventListener('DOMContentLoaded',function(){

/* 12. Scroll-to-reviews */
(function(){
  var stars=document.querySelector('.rating,.product__rating');
  if(!stars||document.querySelector('.wwp-review-link'))return;
  var reviews=document.querySelector('#shopify-product-reviews,.review-section,.spr-reviews,[id*="reviews"]');
  if(!reviews)return;
  var a=document.createElement('a');
  a.className='wwp-review-link';
  a.href='#';
  a.textContent='Read reviews';
  a.style.cssText='font-size:12px;color:#CA9365;text-decoration:underline;display:inline-block;margin-left:6px;vertical-align:middle';
  a.addEventListener('click',function(e){
    e.preventDefault();
    reviews.scrollIntoView({behavior:'smooth',block:'start'});
  });
  stars.appendChild(a);
})();

/* 13. Cart count pulse */
(function(){
  document.querySelectorAll('[name="add"],.product-form__submit').forEach(function(btn){
    if(btn.dataset.wwpPulse)return;
    btn.dataset.wwpPulse='true';
    btn.addEventListener('click',function(){
      setTimeout(function(){
        var badge=document.querySelector('.cart-count-bubble,.header__cart-count');
        if(badge){badge.style.transform='scale(1.4)';badge.style.transition='transform .15s';setTimeout(function(){badge.style.transform='scale(1)'},200);}
      },600);
    });
  });
})();

});
